export default __webpack_public_path__ + "static/media/ew-set.9e434c04.png";